import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { CircularProgress } from '@mui/material';

//
function SpecialBtn(props: any) {

    function onClickHandler() {
        if (props.disabled) {
            return;
        }

        props.onClick();
    }

    let bgImg = "url(/mint/btn2.png)";

    if (props.variant === 'blue') {
        bgImg = "url(/mint/btn_Blue.png)";
    }
    else if (props.variant === 'grey') {
        bgImg = "url(/mint/btn_Grey.png)";
    }
    else if (props.variant === 'red') {
        bgImg = "url(/mint/btn_Red.png)";
    }
    else if (props.variant === 'white') {
        bgImg = "url(/mint/btn_White.png)";
    }
    else if (props.variant === 'gold') {
        bgImg = "url(/mint/btn_Golden.png)";
    }

    // If disabled!
    if(props.disabled) {
        bgImg = "url(/mint/btn_Grey_Transparent.png)";
    }

    return (
        <Box onClick={onClickHandler}
            sx={{
                backgroundImage: bgImg,
                opacity: props.inProg || props.disabled ? "1!important" : '',
                cursor: props.inProg || props.disabled ? '' : 'pointer',
                width: props.width ? props.width : "250px",
                height: props.height ? props.height : "54px",
            }}
            className={props.className}>
            {props.inProg && <CircularProgress size={22} sx={{ marginRight: "10px", color: "white" }} />}

            {!props.inProg &&
                <Box style={{ color: props.textColor ? props.textColor : "white", fontWeight: 700, fontSize: props.labelSize ? props.labelSize : "21px" }}>
                    {props.label}
                </Box>}
        </Box>
    )
}

// Default style!
const SpecialBtnStyled = styled(SpecialBtn)({
    lineHeight: 0,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundPosition: "0% 0%",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    transition: "all 0.5s",
    "&:hover": {
        opacity: 0.75,
    }
});

// Export
export default SpecialBtnStyled;